import React from 'react';
import ReportHelper from '../../../../helpers/ReportHelper';
import PropTypes from 'prop-types';
import style from '../OutcomeFactors/style/outcomefactors.scss';

const OutcomeFactors = ({
        competencies,
        intellectualCapability,
        languageId,
        i18n,
        classes
    }) => {
    return (
        <React.Fragment>
            <div className={`${style.factors} ${classes.root}`}>
                <ul>
                    {intellectualCapability ? <li key={intellectualCapability.name}>
                        <div>
                            <h4>{intellectualCapability.name}</h4>
                            <p className={intellectualCapability.score < intellectualCapability.cutoff ? style.negative : style.positive}>
                                {intellectualCapability.score < intellectualCapability.cutoff
                                    ? i18n.report_section_decision_module_outcome_scale_failed
                                    : i18n.report_section_decision_module_outcome_scale_passed}
                            </p>
                        </div>
                    </li> : null}
                    {competencies && competencies.length ? competencies.map(competency => {
                        return competency.score && competency.cutoff ? <li key={competency.name}>
                            <div>
                                <h4>{ReportHelper.getCompetencyName(competency, languageId, i18n)}</h4>
                                <p className={competency.score < competency.cutoff ? style.negative : style.positive}>
                                    {competency.score < competency.cutoff
                                        ? i18n.report_section_decision_module_outcome_scale_failed
                                        : i18n.report_section_decision_module_outcome_scale_passed}
                                </p>
                            </div>
                        </li> : null;
                    }) : null}
                </ul>
            </div>
        </React.Fragment>
    );
};

export default OutcomeFactors;

OutcomeFactors.propTypes = {
    intellectualCapability: PropTypes.object,
    competencies: PropTypes.array,
    languageId: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired,
    classes: PropTypes.object
};

OutcomeFactors.defaultProps = {
    classes: { root: '' }
};
